function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class TG_DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Cover-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();

    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

if (!customElements.get('deferred-media')) {
  customElements.define('deferred-media', TG_DeferredMedia);
}
class TG_ProductCardColorSwatch {
  constructor() {
    this.element = document.body;
    this.delegateElement = new themegoal.libs.Delegate(this.element);

    this.delegateElement.on('change', '.ProductCard__ColorSwatchRadio', this._colorChanged.bind(this));
  }

  _colorChanged(event, target) {
    // We need to change the URL of the various links, and various id
    let productItem = target.closest('.ProductCard'),
        variantUrl = target.getAttribute('data-variant-url');
   

    productItem.querySelector('.ProductCard__ImageWrapper > a').setAttribute('href', variantUrl);
    productItem.querySelector('.ProductCard__Title > a').setAttribute('href', variantUrl);

    // If we have a custom image for the variant, we change it
    var originalImageElement = productItem.querySelector('.ProductCard__Image:not(.ProductCard__Image--alternate)');

    if (target.hasAttribute('data-image-url') && target.getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {
      var newImageElement = document.createElement('img');
      newImageElement.className = 'ProductCard__Image';
      newImageElement.setAttribute('data-image-id', target.getAttribute('data-image-id'));
      newImageElement.setAttribute('src', target.getAttribute('data-image-url'));
      newImageElement.setAttribute('srcset', target.getAttribute('data-image-srcset'));

      // Replace the original node
      if (window.theme.productImageSize === 'natural') {
        originalImageElement.parentNode.style.setProperty('--tg-aspect-ratio', target.getAttribute('data-image-aspect-ratio'));
      }

      originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
    }

   
  }
}



class TG_SearchDrawer {
  constructor() {
    this.documentDelegate = new themegoal.libs.Delegate(document.body);

    this.searchElement = document.getElementById('SearchDrawer');

    if(this.searchElement){
      this.searchInputElement = this.searchElement.querySelector('[name="q"]');
      this.searchResultsElement = this.searchElement.querySelector('.SearchDrawer__Results');
      this.queryMap = {};

      this._bindEventsListeners();
    }
  }

  destroy() {

    this.searchInputElement.removeEventListener('input', this._onInputListener);

    this.documentDelegate.off();
  }

  _bindEventsListeners() {
    let _this = this;
    this.searchElement.addEventListener('shown.tg.Drawer', event => {
      _this.searchInputElement.focus();
    });

    this._onInputListener = this._debounce(this._onInput.bind(this), 250);


    this.searchInputElement.addEventListener('input', this._onInputListener);

  
    this.documentDelegate.on('search:close', this._closeSearch.bind(this)); // Allow for third-party elements to close the bar
  }

  
  _closeSearch(){
    let searchDrawerElement = document.getElementById('SearchDrawer')
    let searchDrawer = new themegoal.components.Drawer(searchDrawerElement);
    searchDrawer.hide();
  }

  _onInput(event) {
    let _this = this;

    if (event.keyCode === 13) {
      return;
    }

    // Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
    // keep track of sent requests, and only use the results of the last one
    this.lastInputValue = event.target.value;

    if (this.lastInputValue === '') {
      this._resetSearch();
      return;
    }

    var queryOptions = { method: 'GET', credentials: 'same-origin' };

    var queries = [fetch(window.routes.searchUrl + '?q=' + encodeURIComponent(this.lastInputValue) + '&type=' + window.theme.searchMode + '&options[prefix]=last', queryOptions)];

    this.queryMap[this.lastInputValue] = true;

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    Promise.all(queries).then(function (responses) {
      // If we receive the result for a query that is not the last one, we simply do not process the result
      if (_this.lastInputValue !== event.target.value) {
        return;
      }

      delete _this.queryMap[event.target.value];

      Promise.all(responses.map(function (response) {
        return response.text();
      })).then(function (contents) {
        var tempElement = document.createElement('div');
        tempElement.innerHTML = contents[0];

        // If we have only one content then we only have product, otherwise we have products and articles
        _this.searchResultsElement.querySelector('.Results__Content').innerHTML = tempElement.querySelector('.FilterProducts__Content').innerHTML;
        if(tempElement.querySelector('.Results__SummaryForSearchDrawer')){
          _this.searchResultsElement.querySelector('.Results__Summary').innerHTML = tempElement.querySelector('.Results__SummaryForSearchDrawer').innerHTML;
        }

        
        _this.searchResultsElement.setAttribute('aria-hidden', 'false');
      });

      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
  }

  _resetSearch() {
    this.searchResultsElement.querySelector('.Results__Content').innerHTML = '';
    this.searchResultsElement.querySelector('.Results__Summary').innerHTML = '';
    this.searchResultsElement.setAttribute('aria-hidden', 'true');
    document.dispatchEvent(new CustomEvent('theme:loading:end')); // Just in case
  }

  _debounce(fn, delay) {
    var _this = this;

    var timer = null;

    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this, args);
      }, delay);
    };
  }

}

